<template>
	<div class="tw-px-7 degree-factor-navigation">
		<card-navigation
			@onNextClick="$emit('onNextClick')"
			@onPrevClick="$emit('onPrevClick')"
			:disable-prev-button="disablePrevButton"
			:disable-next-button="disableNextButton"
		>
			<div class="tw-px-10 tw-py-6 tw-flex tw-justify-between">
				<div class="degree-factor-navigation-factor tw-flex tw-items-center tw-w-6/12">
					<img :src="selectedFactor.urlImage" alt='' class="tw-mr-2">
					<h2 class="tw-m-0 text-info">{{ selectedFactor.name }}</h2>
				</div>
				<div class="degree-factor-navigation-rate tw-px-8 tw-py-4 tw-w-3/12 tw-flex tw-justify-between tw-items-center">
					<span class="text-secondary font-weight-bold text-2xl">PGM</span>
					<span class="text-info font-weight-bold text-3xl" style="opacity: 0.7;">
						{{ pgMax }}
					</span>
				</div>
				<div class="degree-factor-navigation-rate tw-px-8 tw-py-4 tw-w-3/12 tw-flex tw-justify-between tw-items-center">
					<span class="text-secondary font-weight-bold text-2xl">PGm</span>
					<span class="text-info font-weight-bold text-3xl" style="opacity: 0.7;">{{ pgMin }}</span>
				</div>
			</div>
		</card-navigation>
	</div>
</template>

<script>
import CardNavigation from '@/modules/shared/components/ui/CardNavigation';

export default {
	name: 'DegreeFactorNavigation',
	components: { CardNavigation },
	props: ['selectedFactors', 'selectedFactor', 'pgMax', 'disablePrevButton', 'disableNextButton', 'pgMin'],
};
</script>

<style lang="scss" scoped>
.degree-factor-navigation {
	.degree-factor-navigation-factor {
		img {
			width: 30px;
			height: 30px;
		}
	}
	.degree-factor-navigation-rate {
		border-left: 2px solid var(--app-color-gray);
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/degrees/DegreeFactorNavigation.vue